import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import ActionButton from "../../components/common/buttons/ActionButton";
import { Box, Chip, IconButton } from "@mui/material";
import { message, Popconfirm } from "antd";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useMe } from "../../auth/MeContext";
import { PERM } from "../../auth/permissions";
import { useNavigate } from "react-router-dom";
import AddModal from "../../components/category/AddModal";
import Card from "../../components/common/Card";
import MuiTable from "../../components/common/MuiTable";
import api from "../../hooks/api";
import { Column } from "../../utils/constants";
import { pathAPI } from "../../utils/pathApi";

const Category = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { can } = useMe();
  const [openAddModal, setOpenAddModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  var currentLang: any = localStorage.getItem("language");
  
  useEffect(() => {
    // mutate();
    getCategory();
  }, []);

  const deleteSuccess = () => {
    messageApi.open({
      type: "success",
      content: t("category.messages.delete_success"),
    });
  };

  const deleteError = () => {
    messageApi.open({
      type: "error",
      content: t("category.messages.error"),
    });
  };

  const handleDelete = async (id: number) => {
    try {
      setLoadingDelete(true);
      await api.DELETE(`${pathAPI.categoryDetail}/${id}`, {}, {}, true);
      deleteSuccess();
      // Refresh data
      await getCategory();
    } catch (error) {
      deleteError();
    } finally {
      setLoadingDelete(false);
    }
  };

  const header: Column[] = [
    {
      id: "id",
      label: `${t("common.table.id")}`,
      minWidth: 170,
      align: "center",
    },
    {
      id: "name",
      label: `${t("common.table.name")}`,
      minWidth: 150,
      align: "center",
      format: (value) => {
        return <div className="font-bold ">{value}</div>;
      },
    },
    {
      id: "child_count",
      label: `${t("common.table.child")}`,
      minWidth: 170,
      align: "center",
      format: (value) => {
        return <div className="font-bold">{value}</div>;
      },
    },
    {
      id: "active",
      label: `${t("common.table.active")}`,
      minWidth: 20,
      align: "center",
      format: (value: any) => {
        return (
          <Chip
            size="small"
            variant="outlined"
            color={value ? "success" : "error"}
            label={`${value}`}
          />
        );
      },
    },
    {
      id: "action",
      label: `${t("common.table.actions")}`,
      minWidth: 100,
      align: "center",
      format: (id: number) => {
        return (
          <Box display={"flex"} justifyContent={'center'} alignItems={"center"} gap={2}>
            <Box
              size={"small"}
              component={IconButton}
              disabled={loadingDelete}
              onClick={() => navigate(`${id}`)}
            >
              <EditIcon color="success" />
            </Box>
            {can(PERM.CATEGORY_DELETE) && (
            <Popconfirm
              title={t("help_support.delete_text")}
              okText={t("btn.confirm")}
              cancelText={t("btn.cancel")}
              onConfirm={() => handleDelete(id)}
              okButtonProps={{
                style: { background: "#ba2156", border: "none" },
                loading: loadingDelete,
              }}
            >
              <Box size={"small"} component={IconButton}>
                <DeleteIcon color={"error"} />
              </Box>
            </Popconfirm>
            )}
          </Box>
        );
      },
    },
  ];

  const getCategoryNameByLang = (category: any): string => {
    // Find translation matching current language
    const translation = category.category_translations?.find(
      (trans: any) => trans.language?.code === currentLang
    );

    // Return translated name or fallback to first available translation or empty string
    return translation?.name ||
           category.category_translations?.[0]?.name ||
           t("category.unnamed");
  };

  const getCategory = async () => {
    try {
      setLoading(true);
      const response = await api.GET(pathAPI.category, {}, {}, true);

      if (response && response.data) {
        const updatedData = response.data.map((item: any) => ({
          ...item,
          name: getCategoryNameByLang(item), // Extract name based on currentLang
          action: item.id,
        }));
        setData(updatedData);
      }
    } catch (error) {
      message.error(t("category.load_failed"));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      {can(PERM.CATEGORY_CREATE) && (
      <Box textAlign={"right"} mb={2}>
        <ActionButton startIcon={<AddIcon />} onClick={() => setOpenAddModal(true)}>
          {t("category.add_new")}
        </ActionButton>
      </Box>
      )}
      <MuiTable header={header} data={data} isLoading={isLoading}></MuiTable>
      <AddModal
        open={openAddModal}
        mutate={getCategory}
        onCancel={() => setOpenAddModal(false)}
      />
      {contextHolder}
    </Card>
  );
};

export default Category;
